import { createAction, props } from '@ngrx/store';
import { QcResponse } from 'src/app/shared/models/qcResponse.model';
import { CheckbooksTypesResponse } from '../models/search-checkbooks.model';

export const PanelStatusChanged = createAction('[Checkbooks: Search]: Panel Status Changed');

export const SelectedTypeChanged = createAction(
  '[Checkbooks: Search]: Change Selected Type',
  props<{ selectedTypeId: number | null }>(),
);

export const GetCheckbooksTypes = createAction('[Checkbooks: Search]: Get Checkbooks Types');

export const GetCheckbooksTypesSuccess = createAction(
  '[Checkbooks: Search]: Get Checkbooks Types Success',
  props<{ response: CheckbooksTypesResponse[] }>(),
);

export const GetCheckbooksTypesFailed = createAction(
  '[Checkbooks: Search]: Get Checkbooks Types Failed',
  props<{ error: any }>(),
);

export const CardNumberChanged = createAction(
  '[Checkbooks: Search]: Card Number Changed',
  props<{ cardNumber: string }>(),
);

export const GivenDateChanged = createAction(
  '[Checkbooks: Search]: Given Date Changed',
  props<{ givenDate: Date; givenDateFormat: string }>(),
);

export const GivenDateCleared = createAction('[Checkbooks: Search]: Given Date Cleared');

export const CheckbookCodeChanged = createAction(
  '[Checkbooks: Search]: Checkbook Code Changed',
  props<{ checkbookCode: string }>(),
);

export const InvoiceNumberChanged = createAction(
  '[Checkbooks: Search]: Invoice Number Changed',
  props<{ invoiceNumber: string | null }>(),
);

export const GivenStatusChanged = createAction(
  '[Checkbooks: Search]: Given Status Changed',
  props<{ givenStatus: boolean }>(),
);

export const GetCheckbooks = createAction('[Checkbooks: Search]: Get Checkbooks');

export const GetCheckbooksSuccess = createAction(
  '[Checkbooks: Search]: Get Checkbooks Success',
  props<{ response: QcResponse }>(),
);

export const GetCheckbooksFailed = createAction(
  '[Checkbooks: Search]: Get Checkbooks Failed',
  props<{ error: any }>(),
);

export const CountCheckbooksByFilter = createAction(
  '[Checkbooks: Search]: Count Checkbooks By Filter',
);

export const CountCheckbooksByFilterSuccess = createAction(
  '[Checkbooks: Search]: Count Checkbooks By Filter Success',
  props<{ response: any }>(),
);

export const CountCheckbooksByFilterFailed = createAction(
  '[Checkbooks: Search]: Count Checkbooks By Filter Failed',
  props<{ error: any }>(),
);

export const ClearCheckbooksFilters = createAction(
  '[Checkbooks: Search]: Clear Checkbooks Filters',
);

export const GetCouponSet = createAction('[Checkbooks: Search]: Get CouponSet');

export const GetCouponSetSuccess = createAction(
  '[Checkbooks: Search]: Get CouponSet Success',
  props<{ response: any }>(),
);

export const GetCouponSetFailed = createAction(
  '[Checkbooks: Search]: Get CouponSet Failed',
  props<{ error: any }>(),
);
